module.exports = __webpack_public_path__ + "static/media/EDBg.5888fa09.png";